import styled, { css } from "styled-components";
import { colors } from "theme/colors";
import { SearchBarTypes } from "./types";

export const SearchInput = styled("input")`
    outline: none;
    border: none;
    background-color: ${colors.background};
    border-radius: 28px;
    padding: 10px 14px;
    &::placeholder {
        font-size: 12px;
        color: ${colors.grey.secondary};
    }
`;

export const SearchIcon = styled("button")`
    outline: none;
    border: none;
    background-color: ${colors.purple.primary};
    margin-left: 12px;
    border-radius: 50%;
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    &:hover {
        transform: scale(1.05);
    }
`;

export const SearchBarWrapper = styled.form<SearchBarTypes>`
    display: flex;
    ${({ variant }) =>
        variant === "compact"
            ? css`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #e0e7ec;
                  padding: 0 17px;
                  width: fit-content;
                  border-radius: 50px;

                  #search-bar-options-icon {
                      cursor: pointer;
                  }

                  ${SearchInput} {
                      background-color: #fff;
                  }

                  ${SearchIcon} {
                      display: none;
                  }
              `
            : css`
                  #search-bar-compact-search-icon,
                  #search-bar-compact-options-icon {
                      display: none;
                  }
              `}
`;
